<template>
    <div class="credit-layout">
        <router-view></router-view>
        <WatermarkOverlay
            :enabled="watermark.enabled"
            :text="watermark.text"
            :color="watermark.color"
            :font-size="watermark.fontSize"
            :rotate="watermark.rotate"
            :gap="watermark.gap"
        />
    </div>
</template>

<script>
import request from "@/utils/request";
import useCache from "@/utils/user";
import { user } from "@/store/index";
import { mapActions } from "pinia";
import { getWatermarkConfig } from "@/api/watermark";
import { getWxAuthUrl } from "@/api/wxAuth";
import WatermarkOverlay from "@/components/WatermarkOverlay.vue";
require("@/style/common.css")

export default {
    components: {
        WatermarkOverlay,
    },
    props: {
        code: {
            type: String,
            default: "",
        },
        state: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            APPID: "wx30c19544fb01dee9",
            domain: "https://szszqrsy.cn",
            hasLoadedUserInfo: false,
            authRedirecting: false,
            watermark: {
                enabled: false,
                text: "",
                color: "rgba(21,102,193,0.10)",
                fontSize: 14,
                rotate: -20,
                gap: 120,
            },
        }
    },
    created() {
        this.handleRouteState();
    },
    watch: {
        "$route.fullPath"() {
            this.handleRouteState();
        }
    },
    methods: {
        ...mapActions(user, ["setUserInfo"]),
        isBypassAuthRoute() {
            const path = this.$route.path || "";
            return path === "/credit/login" || path === "/credit/wx-callback" || path === "/credit/bind-account";
        },
        isWeChatBrowser() {
            const ua = (window.navigator.userAgent || "").toLowerCase();
            return ua.indexOf("micromessenger") > -1;
        },
        getInviteScene() {
            const query = this.$route.query || {};
            const value = Number(query.inviteScene || query.inviterId || query.invitedid || 0);
            return value > 0 ? value : undefined;
        },
        handleRouteState() {
            if (!useCache.isLogin()) {
                this.hasLoadedUserInfo = false;
                this.watermark.enabled = false;
                if (this.isBypassAuthRoute()) {
                    return;
                }
                this.handleUnauthenticated();
                return;
            }
            if (this.$route.path === "/credit/login" || this.$route.path === "/credit/bind-account") {
                this.$router.replace({ path: "/credit/home" });
                return;
            }
            if (!this.hasLoadedUserInfo) {
                this.syncCurrentUser();
                return;
            }
            this.loadWatermarkConfig();
        },
        handleUnauthenticated() {
            if (this.authRedirecting) {
                return;
            }
            if (this.isWeChatBrowser()) {
                this.redirectToWxAuth();
                return;
            }
            this.$router.replace({
                path: "/credit/login",
                query: { source: "credit" }
            })
        },
        redirectToWxAuth() {
            this.authRedirecting = true;
            getWxAuthUrl({
                source: "credit",
                inviteScene: this.getInviteScene(),
            }).then((res) => {
                const url = res && res.data && res.data.data;
                if (!url) {
                    throw new Error("未获取到授权地址");
                }
                window.location.replace(url);
            }).catch(() => {
                this.authRedirecting = false;
                this.$router.replace({
                    path: "/credit/login",
                    query: { source: "credit" }
                })
            });
        },
        isAuthFailure(error) {
            const message = String((error && error.message) || "");
            return message.includes("请重新登录") || message.includes("无效的Token") || message.toLowerCase().includes("token");
        },
        syncCurrentUser() {
            request.get("/User/AccountMng/GetUserInfo").then((res) => {
                const userData = res.data.data;
                this.setUserInfo(userData);
                useCache.cacheUserData(userData);
                this.hasLoadedUserInfo = true;
                this.authRedirecting = false;
                this.loadWatermarkConfig();
            }).catch((error) => {
                this.hasLoadedUserInfo = false;
                this.authRedirecting = false;
                if (this.isAuthFailure(error)) {
                    useCache.clearToken();
                    if (!this.isBypassAuthRoute()) {
                        this.handleUnauthenticated();
                    }
                }
            });
        },
        loadWatermarkConfig() {
            getWatermarkConfig().then((res) => {
                const data = (res && res.data && res.data.data) || {};
                this.watermark = {
                    enabled: !!data.enabled,
                    text: data.text || "",
                    color: data.color || "rgba(21,102,193,0.10)",
                    fontSize: Number(data.fontSize || 14),
                    rotate: Number(data.rotate || -20),
                    gap: Number(data.gap || 120),
                };
            }).catch(() => {
                this.watermark.enabled = false;
            });
        },
    }
}
</script>

<style lang="less" scoped>
.credit-layout {
    min-height: 100vh;
    position: relative;
}
</style>
